import React, { useState } from 'react';
import { Button, Input } from '@material-tailwind/react';
import MaintenanceModal from './MaintenanceModal';

// Gate between a card being dropped/set to Completed and the status actually
// changing — a ticket can't land in Completed without an actual cost attached
// (enforced here for the fast path, and again server-side as the real guarantee).
const CompleteWorkOrderModal = ({ isOpen, onClose, workOrder, onConfirm, isSubmitting }) => {
    const [actualCost, setActualCost] = useState('');

    const handleClose = () => {
        setActualCost('');
        onClose();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (actualCost === '') return;
        onConfirm(Number(actualCost));
        setActualCost('');
    };

    if (!workOrder) return null;

    return (
        <MaintenanceModal isOpen={isOpen} onClose={handleClose} title="Enter Actual Cost to Complete" maxWidth="sm">
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <p className="text-sm text-[#6B675F]">
                    "<span className="font-semibold text-inv-ink">{workOrder.title}</span>" needs an actual cost logged before it can move to Completed.
                </p>
                <Input
                    type="number"
                    label="Actual Cost (PKR) *"
                    value={actualCost}
                    onChange={(e) => setActualCost(e.target.value)}
                    min="0"
                    autoFocus
                    required
                />
                <div className="flex justify-end gap-2">
                    <Button variant="text" className="rounded-full" onClick={handleClose} type="button">Cancel</Button>
                    <Button
                        type="submit"
                        className="rounded-full bg-inv-brand shadow-none hover:bg-inv-brand-dark"
                        disabled={actualCost === ''}
                        loading={isSubmitting}
                    >
                        Mark Completed
                    </Button>
                </div>
            </form>
        </MaintenanceModal>
    );
};

export default CompleteWorkOrderModal;
